Object.defineProperty(module.exports, "__esModule", {
  value: true
})

module.exports.default = function(tokens) {
  return {
    chartForegroundColor: tokens.themeForegroundPrimaryDefault,
    chartBackgroundColor: tokens.themeBackgroundPrimaryDefault,
    chartAxisBorderWidth: 2,
    chartAxisBorderColor: tokens.themeBorderSecondaryDefault,
    chartGridBorderWidth: 1,
    chartGridBorderColor: tokens.themeBorderTertiaryDefault,
    chartTrendLineWidth: 3,
    chartTrendLineColor: tokens.themeBorderSecondaryDefault,
    chartBorderWidth: 1,
    chartLabelSpacing: 8,
    chartLabelFontFamily: "\"Amazon Ember Display\", \"Amazon Ember\", Arial, sans-serif",
    chartLabelFontSizeV300: 16,
    chartLabelFontSizeV200: 14,
    chartLabelFontSizeV100: 12,
    chartLabelFontWeightRegular: 400,
    chartLabelFontWeightBold: 600,
    chartBarBorderRadius: 4
  }
};